export default "__VITE_ASSET__0b65284b__"